import {
    ExcelExport,
    ExcelExportColumn,
} from '@progress/kendo-react-excel-export'
import dayjs from 'dayjs'
import React from 'react'

const ExportData = React.forwardRef((props, ref) => {
    let excelData = props.data
    
    excelData = excelData.map((res) => {
        if (res['ETA_TM_XD'] !== ""){
            return {
                ...res,
                ETA_TM_XD:
                    dayjs(res['ETA_TM_XD']).get('hour') +
                    ':' +
                    dayjs(res['ETA_TM_XD']).get('minute'),
            }
        } else {
            return res;
        }

    });

    console.log(excelData)
    return (
        <>
            <ExcelExport
                data={excelData}
                ref={ref}
                fileName={'XDockReport.xlsx'}
            >
                <ExcelExportColumn
                    field="HAWB"
                    title="HAWB"
                    width={'150px'}
                    locked={true}
                />
                <ExcelExportColumn
                    field="SCAC"
                    title="SCAC"
                    width={'80px'}
                    locked={true}
                />
                <ExcelExportColumn field="MAWB" title="MAWB" width={'150px'} />
                <ExcelExportColumn
                    field="DES_LOC_PORT"
                    title="DestLocationPort"
                    width={'150px'}
                />
                <ExcelExportColumn
                    field="ETA_DT_XD"
                    title="XD ETA Date (MM/DD/YYYY)"
                    width="150px"
                    editor="date"
                    format="{0:d}"
                />
                <ExcelExportColumn
                    field="ETA_TM_XD"
                    title="XD ETA Time (HH:MM in 24Hrs)"
                    width="150px"
                />
                <ExcelExportColumn
                    field="TZONE"
                    title="TimeZone"
                    width="150px"
                />
                <ExcelExportColumn field="WGT" title="Weight" width="150px" />
                <ExcelExportColumn
                    field="WGT_TYPE"
                    title="Weight Unit"
                    width="150px"
                />
                <ExcelExportColumn
                    field="REMARKS"
                    title="Remarks"
                    width="150px"
                    editor="text"
                />
            </ExcelExport>
        </>
    )
})

export default ExportData
